import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faDownload } from '@fortawesome/free-solid-svg-icons';
import { useImagePreview } from '../../../contexts/ImagePreviewContext';
import { downloadAttachment } from '../../../utilities/fileUtils';

export const ImagePreviewModal: React.FC = () => {
    // ✨ Subscribe to the context
   const { isOpen, imageSrc, imageName, close, isClosing, message } = useImagePreview();


    if (!isOpen) {
        return null;
    }

    // This function triggers the download using the blob URL from the context.
  const handleDownload = () => {
    if (!message) return;
    downloadAttachment(message);
};
    
    // Prevents clicks inside the modal content from closing it.
    const handleContentClick = (e: React.MouseEvent) => e.stopPropagation();

    return (
        <div 
            onClick={close} 
            className={`fixed inset-0 flex items-center justify-center ${isClosing ? 'animate-fade-out' : 'animate-fade-in'}`}
            role="dialog"
            aria-modal="true"
            aria-label="Image Preview"
            style={{ zIndex: "10000", backgroundColor: "rgba(0, 0, 0, 0.75)"}}
        >
            <style>{`
                .animate-fade-in { animation: fadeIn 0.2s ease-out; }
                .animate-fade-out { animation: fadeOut 0.2s ease-in forwards; }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }
            `}</style>
            <div 
                onClick={handleContentClick}
                className="relative flex flex-col max-w-[90vw] max-h-[90vh] p-4"
            >
                <div className="flex justify-end items-center pb-2 flex-shrink-0">
                    <button
                        onClick={handleDownload}
                        className="text-white hover:text-gray-300 text-xl px-3 py-1 rounded-md transition-colors"
                        title="Download image"
                        aria-label="Download image"
                    >
                        <FontAwesomeIcon icon={faDownload} />
                    </button>
                    <button
                        onClick={close}
                        className="text-white hover:text-gray-300 text-2xl px-3 py-1 rounded-md transition-colors"
                        title="Close preview"
                        aria-label="Close preview"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
                
                <div className="flex items-center justify-center flex-1 min-h-0 overflow-hidden">
                    <img 
                        src={imageSrc || undefined} 
                        alt={imageName || 'Preview'} 
                        className="w-100"
                        style={{ height: '80vh' }}
                    />
                </div>
            </div>
        </div>
    );
};
